import * as React from 'react';
import { useEffect } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useDataProvider } from 'react-admin';
import { Box, CircularProgress } from '@mui/material';
import UserEdit from './UserEdit';

//Opettaja-, opiskelija- ja oppilassovellusten tunnukset
const TEACHER_APP_GUID = '0e274549-7a89-4313-8720-0f4588a51f98'; // opepalvelu
const STUDENT_APP_GUID = 'a7faf0f2-3cfc-4f62-9a77-aa75134ac5a4'; // opiskelija
const PUPIL_APP_GUID = '5b846602-4428-4c2d-b12a-d2b56dd722b7'; // oppilas

//Opettaja ohittaa opiskelija/oppilas-tunnukset, jos käyttäjällä on useampi rooli
const resolveRole = (application: Array<{ guid?: string }> = []) => {
    const guids = application.map(a => a.guid);
    if (guids.includes(TEACHER_APP_GUID)) return 'teacher';
    if (guids.includes(STUDENT_APP_GUID)) return 'student';
    if (guids.includes(PUPIL_APP_GUID)) return 'pupil';
    return undefined;
};

//Hakee käyttäjän guidilla ja ohjaa oikean roolin muokkaussivulle (tai geneeriselle /user-sivulle, jos roolia ei tunnisteta)
const UserRoleResolver = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dataProvider = useDataProvider();

    useEffect(() => {
        if (!id) return;
        dataProvider
            .getOne('user', { id })
            .then(({ data }) => {
                const role = resolveRole(data.application);
                navigate(role ? `/${role}/${id}` : `/user/${id}`, {
                    replace: true,
                });
            })
            .catch(() => navigate(`/user/${id}`, { replace: true }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
        </Box>
    );
};

//Käytetään user-resurssin edit-näkymänä: ?resolverole=true ohjaa oikeaan rooliin, muuten normaali käyttäjän muokkaus
const UserEditOrRoleResolver = () => {
    const [searchParams] = useSearchParams();
    if (searchParams.get('resolverole') === 'true') return <UserRoleResolver />;
    return <UserEdit />;
};

export default UserEditOrRoleResolver;
